export const SET_TRANSPORT_BOTTOM_OVERRIDE = 'SET_TRANSPORT_BOTTOM_OVERRIDE';
export const ENABLE_TRANSPORT_BOTTOM_OVERRIDE = 'ENABLE_TRANSPORT_BOTTOM_OVERRIDE';
